// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o36P","content":"styles_content__17Nn-","row":"styles_row__4T0e-","footer":"styles_footer__2M526","phraseLength":"styles_phraseLength__3uCYt"};